import axios from "axios";

// export const imageURL = "http://127.0.0.1:4000";
// export const soketURL = "http://127.0.0.1:4000";
// export const url = "http://127.0.0.1:4000/api";

export const url =
  process.env.REACT_APP_BASE_URL || "https://www.secondlookortho.com/api";
export const imageURL =
  process.env.REACT_APP_PICTURE_URL || "https://www.secondlookortho.com";
export const soketURL =
  process.env.REACT_APP_SOCKET_URL || "https://www.secondlookortho.com";

const token = localStorage.getItem("token");
// console.log("token", token);

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const tokenConfig = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
};
const fileTokenConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${token}`,
  },
};

// Post Login
export const postLogin = (email, password) =>
  axios.post(`${url}/auth/patient/login`, { email, password }, config);

export const validateOtp = (email, code) =>
  axios.post(`${url}/auth/patient/validate-otp`, { email, code }, config);
//Post Sign Up
export const postSignUp = (data) =>
  axios.post(`${url}/auth/patient/signup`, data, config);

export const logoutApi = () => axios.get(`${url}/auth/logout`, tokenConfig);

export const getLoadUser = () =>
  axios.get(`${url}/auth/logged-in-user`, tokenConfig);

export const forgetPassword = (email) =>
  axios.patch(`${url}/auth/forgot-password-web`, email);

export const resetPassword = (data) =>
  axios.patch(`${url}/auth/reset-password-web/${data.token}`, data);

//Patient
export const getPatientProfile = () =>
  axios.get(`${url}/patients/my-profile`, tokenConfig);

export const updatePatientProfile = (obj) =>
  axios.put(`${url}/patients/update-profile`, obj, tokenConfig);

export const getConsultationCounts = () =>
  axios.get(`${url}/patients/dashboard-counts`, tokenConfig);

export const getAllConsultations = () =>
  axios.get(`${url}/consultations/all-consultation/all`, tokenConfig);

export const getUnpaidConsultations = () =>
  axios.get(`${url}/consultations/unpaid-consultation-list`, tokenConfig);

export const getSingleConsultation = (key, obj) =>
  axios.get(
    `${url}/consultations/single-consultation/${key?.queryKey[1]?.id}`,
    tokenConfig
  );

export const CreateConsultation = (obj) => {
  const type = obj.get("consultationType");
  const UpdatedURL =
    type === "written_report_analysis"
      ? `${url}/consultations/create-writtent-report`
      : `${url}/consultations/create-consultation`;
  return axios.post(UpdatedURL, obj, fileTokenConfig);
};

export const pay = (obj) => axios.post(`${url}/payment/pay`, obj, tokenConfig);

export const postContactUs = (obj) =>
  axios.post(`${url}/patients/ask-a-question`, obj, tokenConfig);

export const getList = (key) =>
  axios.get(`${url}/patients/get-array?key=${key}`, tokenConfig);

export const getMedical = () =>
  axios.get(`${url}/admin/get-array?key=medical`, tokenConfig);

export const getTimeSlots = (date) =>
  axios.get(`${url}/consultations/get-all-time-slots/${date}`, tokenConfig);

export const getChatToken = () =>
  axios.get(`${url}/twilio/chat-token`, tokenConfig);

export const getConversations = () =>
  axios.get(`${url}/twilio/get-chat-room`, tokenConfig);

export const updateChatRoomApi = (data) =>
  axios.put(
    `${url}/twilio/update-chat-room/${data?.id}`,
    data?.data,
    tokenConfig
  );

export const getVideoToken = (data) =>
  axios.post(`${url}/twilio/video-token`, data, tokenConfig);

export const getConsultationDetail = async (roomName) => {
  return await axios.get(
    `${url}/consultations/single-consultation/${roomName}`,
    tokenConfig
  );
};

export const getPrice = async () =>
  axios.get(`${url}/consultations/get-price`, tokenConfig);

export const placeReview = async (data) =>
  axios.post(`${url}/review/place-review`, data, tokenConfig);

export const getReviews = async () =>
  axios.get(`${url}/review/get-reviews`, config);

export const markConsultationComplete = async (id) =>
  axios.put(
    `${url}/consultations/complete-consultation/${id}`,
    {},
    tokenConfig
  );

export const getTeam = () => axios.get(`${url}/team/`, tokenConfig);

export const getAllMessages = (id) =>
  axios.get(`${url}/twilio/get-messages/${id}`, tokenConfig);

export const getMyNotifications = () =>
  axios.get(`${url}/notifications/my-notifications`, tokenConfig);
